import auth0 from 'auth0-js';
import { AUTH_CONFIG } from './Auth0Config';

export default class AuthService {

    constructor(props) {
        this.state = {
            //User Data
            name: "User",
            organisationName: "Company"
        };
    }

    auth0 = new auth0.WebAuth({
        domain: AUTH_CONFIG.domain,
        clientID: AUTH_CONFIG.clientID,
        redirectUri: AUTH_CONFIG.redirectUri,
        audience: AUTH_CONFIG.audience,
        responseType: 'token id_token',
        scope: 'openid https://athena.com/user_metadata https://athena.com/app_metadata'
    });

    login() {
        this.auth0.authorize();
    }

    logout() {
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('id_token');
        sessionStorage.removeItem('expires_at');
        this.auth0.logout({
            returnTo: AUTH_CONFIG.logoutUri,
            clientID: AUTH_CONFIG.clientID
        });
    }

    handleAuthentication(history) {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);
                history.push("/");
            } else if (err) {
                console.log(err);
            }
        });
    }

    setSession(authResult) {
        let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
        sessionStorage.setItem('access_token', authResult.accessToken);
        sessionStorage.setItem('id_token', authResult.idToken);
        sessionStorage.setItem('expires_at', expiresAt);
    }

    isAuthenticated() {
        let expiresAt = JSON.parse(sessionStorage.getItem('expires_at')); //Can use localStorage if you dont want to be cleaned on browser closure
        return new Date().getTime() < expiresAt;
    }

    getAccessToken() {
        const accessToken = sessionStorage.getItem('access_token');
        if (!accessToken) {
            throw new Error('No access token found');
        } else if (!this.isAuthenticated()) { //re-auth if has expired
            this.login();
        }
        return accessToken;
    }

    getUserInfo(accessToken, callback) {
        this.auth0.client.userInfo(accessToken, function (err, user) {
            // Now you have the user's information
            callback(user);
        });
    }

    // Client-side UX role check for the admin portal.
    // SECURITY NOTE: this is UX-only. The real gate is the server-side
    // [Authorize(Policy = "GlobalAdmin")] policy in WebInterface/Program.cs.
    // Reads the namespaced `https://athena.com/roles` claim injected by the
    // Auth0 Login Action — same pattern as the gps-monitor app's gps-operator role.
    // Fails closed (returns false) on any decode error, missing token, or
    // unrecognised claim shape. No new npm dep — inline base64url decode.
    hasRole(roleName) {
        if (!roleName) return false;
        let token;
        try {
            token = sessionStorage.getItem('access_token');
            if (!token) return false;
        } catch (e) { return false; }

        // Decode JWT middle segment (base64url -> base64 -> JSON).
        let payload;
        try {
            const parts = token.split('.');
            if (parts.length !== 3) return false;
            const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
            const padded = b64 + '=='.slice(0, (4 - (b64.length % 4)) % 4);
            const json = decodeURIComponent(
                atob(padded).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
            );
            payload = JSON.parse(json);
        } catch (e) {
            // Malformed token — fail closed.
            return false;
        }

        const namespacedRoles = payload['https://athena.com/roles'];
        if (Array.isArray(namespacedRoles) && namespacedRoles
            .map(r => String(r).toLowerCase())
            .indexOf(String(roleName).toLowerCase()) !== -1) {
            return true;
        }

        return false;
    }

}